import { LanguageType, Package, SourceTypeProject } from "@/enums/enums";
import { i18n } from "@/i18n";
import store from "@/store/index";
import Cookies from "js-cookie";

const peakDomain = process.env.VUE_APP_PeakDomain;

export function UserId() {
  let sessionUserId: any = sessionStorage.getItem("eui");
  sessionUserId = sessionUserId ? sessionUserId.PeakDecryption() : null;
  return sessionUserId;
}
export function MerchantId() {
  let sessionMerchantId: any = sessionStorage.getItem("emi");
  sessionMerchantId = sessionMerchantId ? sessionMerchantId.PeakDecryption() : null;
  return sessionMerchantId;
}
export function GetTimezoneOffset() {
  const date = new Date().getTimezoneOffset();
  const timezoneOffset = (date * -1) / 60;
  return timezoneOffset;
}
export function IsSetCookiesInDomain() {
  let isSetDomain = false;

  if (peakDomain) {
    const domainList = location.hostname.split(".");
    const start = -(domainList.length - 1);
    const locationDomain = `.${domainList.slice(start).join(".")}`;

    if (locationDomain == peakDomain) {
      isSetDomain = true;
    }
  }

  return isSetDomain;
}
export function RefreshToken() {
  return Cookies.get("refresh_token");
}
export function AccessToken() {
  return Cookies.get("access_token");
}
export function SetCookiesAccessToken(accessToken: any) {
  if (accessToken) {
    if (IsSetCookiesInDomain()) {
      Cookies.set("access_token", accessToken, { domain: peakDomain });
    } else {
      Cookies.set("access_token", accessToken);
    }
  }
}
export function SetCookiesRefreshToken(refreshToken: any, keepLogin = false) {
  if (refreshToken) {
    if (IsSetCookiesInDomain()) {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30, domain: peakDomain });
      } else {
        Cookies.set("refresh_token", refreshToken, { domain: peakDomain });
      }
    } else {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30 });
      } else {
        Cookies.set("refresh_token", refreshToken);
      }
    }
  }
}
export function RemoveCookiesToken() {
  if (IsSetCookiesInDomain()) {
    Cookies.remove("access_token", { domain: peakDomain });
    Cookies.remove("refresh_token", { domain: peakDomain });
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  } else {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  }
}
export function GetKeepLogin() {
  return Cookies.get("keepLogin");
}
export function SetCookiesKeepLogin() {
  if (IsSetCookiesInDomain()) {
    Cookies.set("keepLogin", true, { expires: 30, domain: peakDomain });
  } else {
    Cookies.set("keepLogin", true, { expires: 30 });
  }
}
export function RemoveCookiesKeepLogin() {
  if (IsSetCookiesInDomain()) {
    Cookies.remove("keepLogin", { domain: peakDomain });
  } else {
    Cookies.remove("keepLogin");
  }
}
export function GetLanguageType() {
  return i18n.locale == "en" ? LanguageType.En : LanguageType.Th;
}

export function SetHeaderService() {
  return {
    headers: {
      source: SourceTypeProject.PeakAsset,
    },
  };
}
export function CheckMerchantPackage(validPackageList: Array<number>) {
  const currentMerchant = store.getters["LogIn/getMerchant"];
  const packageId = currentMerchant.package;
  if (validPackageList.includes(packageId)) {
    return true;
  }
  return false;
}

export function CheckMerchantAFPPackage() {
  return CheckMerchantPackage([Package.AFPFree, Package.AFPLedger, Package.AFPAccountant]);
}
